const getters = {
    getLaborCosts(state) {
        return state.laborCosts;
    },
    getLaborCost(state) {
        return state.labor;
    }
}

export default getters;
